export default __webpack_public_path__ + "static/media/Apple.665f43eb.svg";